require('components/shared.js')


import Vue from 'vue'
window.Event = new Vue()


var VueTouch = require('vue-touch')
Vue.use(VueTouch, {name: 'v-touch'})

import textSlider from 'components/textSlider/textSlider.vue'
import statementSlider from 'components/statementSlider/statementSlider.vue'
import desktopNavigation from 'components/navigation/desktop/desktopNavigation.vue'
import mobileNavigation from 'components/navigation/mobile/mobileNavigation.vue'
import responsiveImage from 'components/image/responsiveImage.vue'


import languageSwitch from 'components/button/languageSwitch.vue'
import customButton from 'components/button/customButton.vue'
import card from 'components/cards/card.vue'

import bootstrapTabs from 'components/tabs/bootstrapTabs.vue'


new Vue({
    el: '#app',

    components: {
        textSlider,
        statementSlider,
        desktopNavigation,
        mobileNavigation,
        languageSwitch,
        customButton,
        bootstrapTabs,
        card,
        responsiveImage
    },
    data() {
        return {}
    },
    mounted() {
    }
})

